import React from 'react';
import { Navigate } from 'react-router-dom';
// Stub component to fix dead import in App.tsx
// Redirects to the actual product manager
const AddProduct = () => {
  return <Navigate to="/vendors/manage" replace data-id="element-4616" data-mp="vw98qmil9fwu" />;
};
export default AddProduct;